/* tslint:disable */
/* eslint-disable */
/**
 * Payment Schedule API
 * API to manage payment schedules (échéances de paiement)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Échéance « mise en avant » d'une quittance (calculée par le back : erreur la plus ancienne, sinon prochaine à venir, sinon dernière traitée).
 * 
 * @export
 * @interface HighlightedInstallmentDto
 */
export interface HighlightedInstallmentDto {
    /**
     * 
     * @type {string}
     * @memberof HighlightedInstallmentDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof HighlightedInstallmentDto
     */
    number: number;
    /**
     * 
     * @type {Date}
     * @memberof HighlightedInstallmentDto
     */
    dueDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof HighlightedInstallmentDto
     */
    withdrawalDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof HighlightedInstallmentDto
     */
    amount: number;
    /**
     * PLANIFIE | TRANSMIS | PAYE | IMPAYE | REJETE | ANNULE
     * @type {string}
     * @memberof HighlightedInstallmentDto
     */
    statusCode: string;
    /**
     * 
     * @type {string}
     * @memberof HighlightedInstallmentDto
     */
    statusLabel: string;
    /**
     * 
     * @type {number}
     * @memberof HighlightedInstallmentDto
     */
    attempts: number;
    /**
     * 
     * @type {string}
     * @memberof HighlightedInstallmentDto
     */
    rejectLabel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HighlightedInstallmentDto
     */
    rejectCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HighlightedInstallmentDto
     */
    lastError?: string | null;
}

/**
 * Check if a given object implements the HighlightedInstallmentDto interface.
 */
export function instanceOfHighlightedInstallmentDto(value: object): value is HighlightedInstallmentDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('dueDate' in value) || value['dueDate'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('statusCode' in value) || value['statusCode'] === undefined) return false;
    if (!('statusLabel' in value) || value['statusLabel'] === undefined) return false;
    if (!('attempts' in value) || value['attempts'] === undefined) return false;
    return true;
}

export function HighlightedInstallmentDtoFromJSON(json: any): HighlightedInstallmentDto {
    return HighlightedInstallmentDtoFromJSONTyped(json, false);
}

export function HighlightedInstallmentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): HighlightedInstallmentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'number': json['number'],
        'dueDate': (new Date(json['dueDate'])),
        'withdrawalDate': json['withdrawalDate'] == null ? undefined : (new Date(json['withdrawalDate'])),
        'amount': json['amount'],
        'statusCode': json['statusCode'],
        'statusLabel': json['statusLabel'],
        'attempts': json['attempts'],
        'rejectLabel': json['rejectLabel'] == null ? undefined : json['rejectLabel'],
        'rejectCode': json['rejectCode'] == null ? undefined : json['rejectCode'],
        'lastError': json['lastError'] == null ? undefined : json['lastError'],
    };
}

export function HighlightedInstallmentDtoToJSON(json: any): HighlightedInstallmentDto {
    return HighlightedInstallmentDtoToJSONTyped(json, false);
}

export function HighlightedInstallmentDtoToJSONTyped(value?: HighlightedInstallmentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'number': value['number'],
        'dueDate': ((value['dueDate']).toISOString()),
        'withdrawalDate': value['withdrawalDate'] == null ? undefined : ((value['withdrawalDate'] as any).toISOString()),
        'amount': value['amount'],
        'statusCode': value['statusCode'],
        'statusLabel': value['statusLabel'],
        'attempts': value['attempts'],
        'rejectLabel': value['rejectLabel'],
        'rejectCode': value['rejectCode'],
        'lastError': value['lastError'],
    };
}

